<div>
    <div class="cmn-flex row space-between">
        <mat-form-field class="flex">
            <mat-placeholder>Name</mat-placeholder>
            <input [(ngModel)]="groupType.group_type" matInput required maxlength="256">
        </mat-form-field>
    </div>
    <div class="cmn-flex row space-between">
        <mat-form-field class="flex">
            <mat-placeholder>Description</mat-placeholder>
            <input [(ngModel)]="groupType.group_type_desc" matInput required maxlength="256">
        </mat-form-field>
    </div>
    <mat-checkbox [(ngModel)]="groupType.use_system_global_intervals"
                  labelPosition="before"
                  matTooltip="Forces groups with this group type to use the global Escalation and Reminder intervals."
    >Use System Global Intervals:
    </mat-checkbox>
</div>
<mat-dialog-actions class="cmn-flex row space-between">
    <button [mat-dialog-close]="this.groupType" color="primary" mat-raised-button>Save</button>
    <button [mat-dialog-close]="false" color="primary" mat-raised-button>Cancel</button>
</mat-dialog-actions>
